import React, { useEffect } from 'react';
import { StaticQuery } from 'gatsby';
import styled, { createGlobalStyle } from '@xstyled/styled-components';
var GlobalStyle = createGlobalStyle(["#carbonads{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen-Sans,Ubuntu,Cantarell,\"Helvetica Neue\",Helvetica,Arial,sans-serif;}#carbonads{display:inline-flex;background-color:background-light;border:1;border-color:layout-border;box-shadow:none;}#carbonads a{color:inherit;text-decoration:none;}#carbonads a:hover{color:inherit;}#carbonads span{position:relative;display:block;overflow:hidden;}#carbonads .carbon-wrap{display:flex;}.carbon-img{display:block;margin:0;line-height:1;}.carbon-img img{display:block;}.carbon-text{font-size:13px;padding:10px;line-height:1.5;text-align:left;}.carbon-poweredby{display:block;padding:8px 10px;background:repeating-linear-gradient(-45deg,transparent,transparent 5px,hsla(0,0%,0%,.025) 5px,hsla(0,0%,0%,.025) 10px) hsla(203,11%,95%,.4);text-align:center;text-transform:uppercase;letter-spacing:.5px;font-weight:600;font-size:9px;line-height:1;}"]);
var QUERY = "2140385554";
var AdContainer = styled.aside.withConfig({
  displayName: "CarbonAd__AdContainer",
  componentId: "sc-1wtkrwl-0"
})(["display:block;height:125;min-width:1;margin:3 0;"]);

function InnerCarbonAd(_ref) {
  var url = _ref.url;
  var ref = React.useRef();
  useEffect(function () {
    var wrapper = ref.current;
    var script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.id = '_carbonads_js';
    wrapper.appendChild(script);
    return function () {
      wrapper.removeChild(script);
    };
  }, [url]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, {
    colorMode: "dark"
  }), /*#__PURE__*/React.createElement("div", {
    ref: ref
  }));
}

export function CarbonAd() {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      return data.site.siteMetadata.carbonAdsURL ? /*#__PURE__*/React.createElement(AdContainer, null, /*#__PURE__*/React.createElement(InnerCarbonAd, {
        url: data.site.siteMetadata.carbonAdsURL
      })) : null;
    }
  });
}